import { Component, EventEmitter, Input, Output } from '@angular/core';
import type { RadioItem } from '@innogy/common-ui/forms';
import { ParsedToolTrackingConfig } from '@analytics/models';
import type {
  SolarPanelsSuitabilityRoofType,
  SolarPanelsSuitabilitySimpleAnswer,
} from '@innogy/feh/models';
import { FormGroupState } from 'ngrx-forms';

import type {
  SolarPanelsSuitabilityCheckFormValues,
  SolarPanelSuitabilityCheckToolTrackingSteps,
} from '../../store';
import { SolarPanelsSuitabilityCheckRendering } from '../../models/solar-panels-suitability-check-rendering.interface';

@Component({
  selector:
    'wl-solar-panels-suitability-check[rendering][formState][trackToolConfig][asbestosOptions][roofTypeOptions][roofReplacedOptions][maximumRoofAge]',
  templateUrl: './solar-panels-suitability-check.component.html',
})
export class SolarPanelsSuitabilityCheckComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering!: SolarPanelsSuitabilityCheckRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formState!: FormGroupState<SolarPanelsSuitabilityCheckFormValues>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input()
  trackToolConfig!: ParsedToolTrackingConfig<SolarPanelSuitabilityCheckToolTrackingSteps>;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showAsbestosQuestion?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showRoofTypeQuestion?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showRenovationDateQuestion?: boolean;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() asbestosOptions!: RadioItem<SolarPanelsSuitabilitySimpleAnswer>[];
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() roofTypeOptions!: RadioItem<SolarPanelsSuitabilityRoofType>[];
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input()
  roofReplacedOptions!: RadioItem<SolarPanelsSuitabilitySimpleAnswer>[];
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() maximumRoofAge!: number;

  @Output()
  submitForm = new EventEmitter<Event>();
}
